<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="mx-auto grid max-w-4xl gap-5">
    <div class="flex gap-2">
      <div
        v-for="index in 4"
        :key="index"
        class="h-7 w-28 animate-pulse rounded-full bg-lais-bg-muted"
      />
    </div>
    <div class="rounded-lais border border-lais-border bg-white p-5">
      <div class="h-5 w-48 animate-pulse rounded bg-lais-bg-muted" />
      <div class="mt-5 grid gap-3">
        <div class="h-10 animate-pulse rounded-lais bg-lais-bg-muted" />
        <div class="h-10 animate-pulse rounded-lais bg-lais-bg-muted" />
        <div class="h-24 animate-pulse rounded-lais bg-lais-bg-muted" />
      </div>
    </div>
  </div>
</template>
